import {
  AssetsFiltersFE,
  AssetsOptionLabelValueFilters,
  AssetsTableColumn,
  getFiltersOfTheAssetsTableStaticColumn,
  isAssetsTableStaticColumn,
  StaticAssetsFilters
} from "../../../../types/internal/tables/assetsTable";
import {Trans, useTranslation} from "react-i18next";
import {useGetHazardTypeClassesQuery} from "../../../../redux/api/hazardTypes";
import {useGetAssetBiodiversityDataSourcesQuery} from "../../../../redux/api/asset";
import {Button, Col, Divider, Popover, Row} from "antd";
import StandardFilter from "../../../common/filters/StandardFilter";
import _, {capitalize} from "lodash";
import {BIODIVERSITY_WITHIN} from "../../../../types/api/assets";
import {VALUE_NOT_PRESENT} from "../../../../utils/translation";
import NumbersFilter from "../../../common/filters/NumbersFilter";
import DatesFilter from "../../../common/filters/DatesFilter";
import {FilterFilled} from "@ant-design/icons";
import React from "react";
import AssetRelatedOptionsFilterCreationAreas from "./AssetRelatedOptionsFilterCreationAreas";
import HazardFilterCreationAreas from "./HazardFilterCreationAreas";
import {useGetAlertParametersTypeQuery} from "../../../../redux/api/alertParameters";
import SingleNumberFilter from "../../../common/filters/SingleNumberFilter";
import {getLabelForAlertParameterFilters} from "../../../assets/AssetsTable/AssetsTableFilter";
import BiodiversityDistanceCreationAreas from "./BiodiversityDistanceCreationAreas";
import BiodiversitySourceFilterCreationAreas from "./BiodiversitySourceFilterCreationAreas";

interface AssetsTableFilterCreationAreasProps {
  columnKey: string,
  filters: AssetsFiltersFE,
  filtersInExcludeMode: AssetsOptionLabelValueFilters[],
  addFilters: (addFilters: AssetsFiltersFE) => void,
  removeFilters: (removeFilters: ((StaticAssetsFilters | 'hazards') | string)[] | ((StaticAssetsFilters | 'hazards') | string)) => void,
  setOverallLandCoverageNullFilter: (source: string) => void,
  removeOverallLandCoverageFilter: (source: string) => void,
  setOverallLandCoverageMinFilter: (source: string, value: number) => void,
  removeOverallLandCoverageMinFilter: (source: string) => void,
  setOverallLandCoverageMaxFilter: (source: string, value: number) => void,
  removeOverallLandCoverageMaxFilter: (source: string) => void,
  insertFilterInExcludeMode: (filterInExcludeMode: AssetsOptionLabelValueFilters) => void,
  removeFilterInExcludeMode: (filterInExcludeMode: AssetsOptionLabelValueFilters) => void,
}

export default function AssetsTableFilterCreationAreas({
                                                         columnKey,
                                                         filters,
                                                         filtersInExcludeMode,
                                                         addFilters,
                                                         removeFilters,
                                                         setOverallLandCoverageNullFilter,
                                                         removeOverallLandCoverageFilter,
                                                         setOverallLandCoverageMinFilter,
                                                         removeOverallLandCoverageMinFilter,
                                                         setOverallLandCoverageMaxFilter,
                                                         removeOverallLandCoverageMaxFilter,
                                                         insertFilterInExcludeMode,
                                                         removeFilterInExcludeMode
                                                       }: AssetsTableFilterCreationAreasProps) {
  const {t} = useTranslation();

  const {
    data: hazardTypes,
  } = useGetHazardTypeClassesQuery();
  const {
    data: biodiversitySources,
  } = useGetAssetBiodiversityDataSourcesQuery();
  const {
    data: alertParametersTypeSources
  } = useGetAlertParametersTypeQuery({paginate: false})

  const isHazardFilter = hazardTypes?.find(ht => ht.code === columnKey);
  const isBioSourceFilter = biodiversitySources?.find(bs => bs.value === columnKey);
  const isAlertParametersFilter = alertParametersTypeSources?.find(param => param.code === columnKey)

  let filter = <></>;
  if (isAssetsTableStaticColumn(columnKey)) {
    switch (columnKey) {
      case 'biodiversity_within':
        filter = <div style={{ maxWidth: '30rem' }}>
          <BiodiversityDistanceCreationAreas
            filters={filters}
            addFilters={addFilters}
            removeFilters={removeFilters}
          />
          <BiodiversitySourceFilterCreationAreas
            filters={filters}
            addFilters={addFilters}
            removeFilters={removeFilters}
          />
          <Divider/>
          <Trans
            i18nKey={'assets.landCoverageDescription'} components={{
            li: <li style={{fontStyle: 'italic'}}/>,
            ul: <ul style={{fontStyle: 'italic'}}/>,
            p: <p style={{fontStyle: 'italic'}}/>
          }}
          />
          <StandardFilter
            selectedFilters={filters.biodiversity_within}
            filters={[
              {label: capitalize(t('assets.landCoverageIn')), value: BIODIVERSITY_WITHIN.IN},
              {label: capitalize(t('assets.landCoverageOut')), value: BIODIVERSITY_WITHIN.OUT},
              {label: VALUE_NOT_PRESENT, value: BIODIVERSITY_WITHIN.NA},
            ]}
            onChange={(values) => {
              if (values.length) {
                addFilters({biodiversity_within: values});
              } else {
                removeFilters('biodiversity_within');
              }
            }}
          />
        </div>;
        break;
      case 'surface_basement':
      case 'surface_total':
      case 'total_resources':
        filter = <NumbersFilter
          numericProps={{
            suffix: (columnKey !== 'total_resources') ? ' mq' : '',
          }}
          onNullChange={(v) => {
            if (v) {
              addFilters({[`is_${columnKey}_null`]: v});
              removeFilters([`${columnKey}_min`, `${columnKey}_max`]);
            } else {
              removeFilters(`is_${columnKey}_null`);
            }
          }}
          onMinChange={(value) => {
            if (typeof value === 'number') {
              addFilters({[`${columnKey}_min`]: value});
            } else {
              removeFilters(`${columnKey}_min`);
            }
          }}
          onMaxChange={(value) => {
            if (typeof value === 'number') {
              addFilters({[`${columnKey}_max`]: value});
            } else {
              removeFilters(`${columnKey}_max`);
            }
          }}
          min={filters[`${columnKey}_min`]}
          max={filters[`${columnKey}_max`]}
          isNull={filters[`is_${columnKey}_null`]}
        />;
        break;
      case 'total_uog_contacts':
        filter = <NumbersFilter
          onMinChange={(value) => {
            if (typeof value === 'number') {
              addFilters({[`${columnKey}_min`]: value});
            } else {
              removeFilters(`${columnKey}_min`);
            }
          }}
          onMaxChange={(value) => {
            if (typeof value === 'number') {
              addFilters({[`${columnKey}_max`]: value});
            } else {
              removeFilters(`${columnKey}_max`);
            }
          }}
          min={filters[`${columnKey}_min`]}
          max={filters[`${columnKey}_max`]}
          isNullable={false}
        />;
        break;
      case 'opening_date':
      case 'closing_date':
        filter = <DatesFilter
          isNull={filters[`is_${columnKey}_null`]}
          start={filters[`${columnKey}_after`]}
          end={filters[`${columnKey}_before`]}
          onNullChange={(value) => {
            if (value) {
              addFilters({[`is_${columnKey}_null`]: value});
              removeFilters([`${columnKey}_after`, `${columnKey}_before`]);
            } else {
              removeFilters(`is_${columnKey}_null`);
            }
          }}
          onStartChange={(value) => {
            if (value) {
              addFilters({[`${columnKey}_after`]: value});
            } else {
              removeFilters(`${columnKey}_after`);
            }
          }}
          onEndChange={(value) => {
            if (value) {
              addFilters({[`${columnKey}_before`]: value});
            } else {
              removeFilters(`${columnKey}_before`);
            }
          }}
        />;
        break;
      case 'acoustic_zone':
      case 'address':
      case 'admin_level_1':
      case 'admin_level_2':
      case 'admin_level_3':
      case 'building_type':
      case 'building_type_detail':
      case 'companies':
      case 'contact_people':
      case 'country':
      case 'is_user_created':
      case 'master_asset':
      case 'ownership':
      case 'postal_code':
      case 'realestate_hub':
      case 'realestate_garrison':
      case 'sigi_code':
      case 'event_cluster':
        filter = <AssetRelatedOptionsFilterCreationAreas
          field={columnKey as any}
          filters={filters}
          filtersInExcludeMode={filtersInExcludeMode}
          addFilters={addFilters}
          removeFilters={removeFilters}
          insertFilterInExcludeMode={insertFilterInExcludeMode}
          removeFilterInExcludeMode={removeFilterInExcludeMode}
        />;
        break;
      default:
        filter = <>
          WORK IN PROGRESS...
        </>;
    }
  } else {
    if (isHazardFilter) {
      filter = <HazardFilterCreationAreas
        column={columnKey}
        filters={filters}
        filtersInExcludeMode={filtersInExcludeMode}
        addFilters={addFilters}
        removeFilters={removeFilters}
      />;
    }
    if (isAlertParametersFilter) {
      const suffix = alertParametersTypeSources?.find(param => param.code === columnKey)?.um
      const limitType = alertParametersTypeSources?.find(param => param.code === columnKey)?.limit_type
      const decimalScale = alertParametersTypeSources?.find(param => param.code === columnKey)?.decimals
      const displayText = getLabelForAlertParameterFilters(limitType, t)
      filter = <SingleNumberFilter
        activeValue={filters?.alert_parameters?.[columnKey]}
        suffix={suffix ?? ""}
        displayText={displayText}
        decimalScale={decimalScale}
        onChange={value => {
          if (typeof value === 'number') {
            addFilters({alert_parameters: {[columnKey]: value}})
          } else {
            removeFilters(columnKey)
          }
        }}
      />
    }
    if (isBioSourceFilter) {
      filter = <NumbersFilter
        numericProps={{
          suffix: ' %',
          allowNegative: false,
        }}
        onNullChange={(v) => {
          if (v) {
            setOverallLandCoverageNullFilter(columnKey);
          } else {
            removeOverallLandCoverageFilter(columnKey);
          }
        }}
        onMinChange={(value) => {
          if (typeof value === 'number') {
            setOverallLandCoverageMinFilter(columnKey, value);
          } else {
            removeOverallLandCoverageMinFilter(columnKey);
          }
        }}
        onMaxChange={(value) => {
          if (typeof value === 'number') {
            setOverallLandCoverageMaxFilter(columnKey, value);
          } else {
            removeOverallLandCoverageMaxFilter(columnKey);
          }
        }}
        min={filters?.overall_land_coverage?.[columnKey]?.min}
        max={filters?.overall_land_coverage?.[columnKey]?.max}
        isNull={filters?.overall_land_coverage?.[columnKey]?.is_null}
      />;
    }
  }

  const isTotalFilterActive = (column: AssetsTableColumn) => {
    if (isAssetsTableStaticColumn(column)) {
      return getFiltersOfTheAssetsTableStaticColumn(column).some(filter => !_.isUndefined(filters[filter]));
    } else {
      return !_.isUndefined(filters.hazards?.[column]) || !_.isUndefined(filters.overall_land_coverage?.[column]) || !_.isUndefined(filters.alert_parameters?.[column]);
    }
  };

  return <Popover
    arrow={false}
    trigger={'click'}
    placement={'bottom'}
    destroyTooltipOnHide
    content={(
      <>
        {filter}
        <Divider/>
        <Row justify={'end'}>
          <Col>
            <Button
              disabled={!isTotalFilterActive(columnKey)}
              type={'link'}
              onClick={() => {
                if (isAssetsTableStaticColumn(columnKey)) {
                  removeFilters(getFiltersOfTheAssetsTableStaticColumn(columnKey));
                } else {
                  if (isHazardFilter) {
                    removeFilters(columnKey);
                  }
                  if (isAlertParametersFilter) {
                    removeFilters(columnKey)
                  }
                  if (isBioSourceFilter) {
                    removeOverallLandCoverageFilter(columnKey);
                  }
                }
              }}
            >
              {capitalize(t('table.removeFilter'))}
            </Button>
          </Col>
        </Row>
      </>
    )}
  >
    <FilterFilled
      style={{
        opacity: '25%',
        ...{
          ...isTotalFilterActive(columnKey) && {color: '#1677ff', opacity: ''},
        },
      }}
    />
  </Popover>;
}
